import script from "./SectionFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionFrame.vue?vue&type=script&setup=true&lang=ts"

import "./SectionFrame.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__